import Permissoes from "@/utils/permissoes";

import { formMode } from "@/utils/form.helpers";

const routes = [
  {
    path: "/seguranca/usuarios",
    name: "usuarios",
    component: () => import("@/views/cadastros/usuarios/index.vue"),
    meta: {
      title: 'Usuários',
      authRequired: true,
      permissoes: [Permissoes.Usuarios],
      menus: [Permissoes.ModuloCadastros, Permissoes.Usuarios]
    },
  },
  {
    path: "/seguranca/usuarios/visualizar/:id",
    name: "usuarios-visualizar",
    component: () => import("@/views/cadastros/usuarios/form.vue"),
    meta: {
      title: 'Usuários',
      authRequired: true,
      formMode: formMode.View,
      permissoes: [Permissoes.VisualizarUsuarios],
      menus: [Permissoes.ModuloCadastros, Permissoes.Usuarios]
    },
  },
  {
    path: "/seguranca/usuarios/editar/:id",
    name: "usuarios-editar",
    component: () => import("@/views/cadastros/usuarios/form.vue"),
    meta: {
      title: 'Usuários',
      authRequired: true,
      formMode: formMode.Edit,
      permissoes: [Permissoes.EditarUsuarios],
      menus: [Permissoes.ModuloCadastros, Permissoes.Usuarios]
    },
  },
  {
    path: "/seguranca/usuarios/cadastrar",
    name: "usuarios-cadastrar",
    component: () => import("@/views/cadastros/usuarios/form.vue"),
    meta: {
      title: 'Usuários',
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.CriarUsuarios],
      menus: [Permissoes.ModuloCadastros, Permissoes.Usuarios]
    },
  },

  {
    path: "/seguranca/papeis-funcoes",
    name: "roles",
    component: () => import("@/views/cadastros/roles/index.vue"),
    meta: {
      title: 'Papéis e Funções',
      authRequired: true,
      permissoes: [Permissoes.PapeisFuncoes],
      menus: [Permissoes.Configuracoes, Permissoes.PapeisFuncoes]
    },
  },
  {
    path: "/seguranca/papeis-funcoes/visualizar/:id",
    name: "roles-visualizar",
    component: () => import("@/views/cadastros/roles/form.vue"),
    meta: {
      title: 'Papéis e Funções',
      authRequired: true,
      formMode: formMode.View,
      permissoes: [Permissoes.VisualizarPapeisFuncoes],
      menus: [Permissoes.Configuracoes, Permissoes.PapeisFuncoes]
    },
  },
  {
    path: "/seguranca/papeis-funcoes/editar/:id",
    name: "roles-editar",
    component: () => import("@/views/cadastros/roles/form.vue"),
    meta: {
      title: 'Papéis e Funções',
      authRequired: true,
      formMode: formMode.Edit,
      permissoes: [Permissoes.EditarPapeisFuncoes],
      menus: [Permissoes.Configuracoes, Permissoes.PapeisFuncoes]
    },
  },
  {
    path: "/seguranca/papeis-funcoes/cadastrar",
    name: "roles-cadastrar",
    component: () => import("@/views/cadastros/roles/form.vue"),
    meta: {
      title: 'Papéis e Funções',
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.CriarPapeisFuncoes],
      menus: [Permissoes.Configuracoes, Permissoes.PapeisFuncoes]
    },
  },

  {
    path: "/seguranca/log-auditoria",
    name: "seguranca-log-auditoria",
    component: () => import("@/views/configuracoes/logs-auditoria/index"),
    meta: {
      title: 'Logs de auditoria',
      authRequired: true,
      roles: [ Permissoes.LogsAuditoria ],
      menus: [Permissoes.Configuracoes, Permissoes.LogsAuditoria]
    },
  },
  {
    path: "/seguranca/log-auditoria/visualizar/:data/:id",
    name: "seguranca-log-auditoria-view",
    component: () => import("@/views/configuracoes/logs-auditoria/form"),
    meta: {
      title: 'Logs de auditoria',
      authRequired: true,
      roles: [ Permissoes.LogsAuditoria ],
      menus: [Permissoes.Configuracoes, Permissoes.LogsAuditoria]
    },
  },
];
export default routes;
